// Catálogo de atributos pré-traduzidos das terapeutas.
// A operadora escolhe SÓ em português; a expansão para EN/ES é automática.
//
// Convenção: cada entrada é um objeto {pt, en, es}. O PT é a chave lógica.
// Manter listas ordenadas alfabeticamente (por pt).

export const NATIONALITIES = [
  { pt: "Alemã", en: "German", es: "Alemana" },
  { pt: "Americana", en: "American", es: "Estadounidense" },
  { pt: "Angolana", en: "Angolan", es: "Angoleña" },
  { pt: "Argentina", en: "Argentinian", es: "Argentina" },
  { pt: "Austríaca", en: "Austrian", es: "Austriaca" },
  { pt: "Belga", en: "Belgian", es: "Belga" },
  { pt: "Boliviana", en: "Bolivian", es: "Boliviana" },
  { pt: "Brasileira", en: "Brazilian", es: "Brasileña" },
  { pt: "Britânica", en: "British", es: "Británica" },
  { pt: "Búlgara", en: "Bulgarian", es: "Búlgara" },
  { pt: "Cabo-verdiana", en: "Cape Verdean", es: "Caboverdiana" },
  { pt: "Canadiana", en: "Canadian", es: "Canadiense" },
  { pt: "Checa", en: "Czech", es: "Checa" },
  { pt: "Chilena", en: "Chilean", es: "Chilena" },
  { pt: "Chinesa", en: "Chinese", es: "China" },
  { pt: "Colombiana", en: "Colombian", es: "Colombiana" },
  { pt: "Coreana", en: "Korean", es: "Coreana" },
  { pt: "Croata", en: "Croatian", es: "Croata" },
  { pt: "Cubana", en: "Cuban", es: "Cubana" },
  { pt: "Dinamarquesa", en: "Danish", es: "Danesa" },
  { pt: "Dominicana", en: "Dominican", es: "Dominicana" },
  { pt: "Egípcia", en: "Egyptian", es: "Egipcia" },
  { pt: "Equatoriana", en: "Ecuadorian", es: "Ecuatoriana" },
  { pt: "Escocesa", en: "Scottish", es: "Escocesa" },
  { pt: "Eslovaca", en: "Slovak", es: "Eslovaca" },
  { pt: "Espanhola", en: "Spanish", es: "Española" },
  { pt: "Filipina", en: "Filipino", es: "Filipina" },
  { pt: "Finlandesa", en: "Finnish", es: "Finlandesa" },
  { pt: "Francesa", en: "French", es: "Francesa" },
  { pt: "Grega", en: "Greek", es: "Griega" },
  { pt: "Guineense", en: "Guinean", es: "Guineana" },
  { pt: "Holandesa", en: "Dutch", es: "Neerlandesa" },
  { pt: "Húngara", en: "Hungarian", es: "Húngara" },
  { pt: "Indiana", en: "Indian", es: "India" },
  { pt: "Indonésia", en: "Indonesian", es: "Indonesia" },
  { pt: "Irlandesa", en: "Irish", es: "Irlandesa" },
  { pt: "Israelita", en: "Israeli", es: "Israelí" },
  { pt: "Italiana", en: "Italian", es: "Italiana" },
  { pt: "Japonesa", en: "Japanese", es: "Japonesa" },
  { pt: "Letã", en: "Latvian", es: "Letona" },
  { pt: "Libanesa", en: "Lebanese", es: "Libanesa" },
  { pt: "Lituana", en: "Lithuanian", es: "Lituana" },
  { pt: "Marroquina", en: "Moroccan", es: "Marroquí" },
  { pt: "Mexicana", en: "Mexican", es: "Mexicana" },
  { pt: "Moçambicana", en: "Mozambican", es: "Mozambiqueña" },
  { pt: "Nigeriana", en: "Nigerian", es: "Nigeriana" },
  { pt: "Norueguesa", en: "Norwegian", es: "Noruega" },
  { pt: "Panamiana", en: "Panamanian", es: "Panameña" },
  { pt: "Paraguaia", en: "Paraguayan", es: "Paraguaya" },
  { pt: "Peruana", en: "Peruvian", es: "Peruana" },
  { pt: "Polaca", en: "Polish", es: "Polaca" },
  { pt: "Portuguesa", en: "Portuguese", es: "Portuguesa" },
  { pt: "Romena", en: "Romanian", es: "Rumana" },
  { pt: "Russa", en: "Russian", es: "Rusa" },
  { pt: "São-tomense", en: "Santomean", es: "Santotomense" },
  { pt: "Sérvia", en: "Serbian", es: "Serbia" },
  { pt: "Sueca", en: "Swedish", es: "Sueca" },
  { pt: "Suíça", en: "Swiss", es: "Suiza" },
  { pt: "Tailandesa", en: "Thai", es: "Tailandesa" },
  { pt: "Tunisina", en: "Tunisian", es: "Tunecina" },
  { pt: "Turca", en: "Turkish", es: "Turca" },
  { pt: "Ucraniana", en: "Ukrainian", es: "Ucraniana" },
  { pt: "Uruguaia", en: "Uruguayan", es: "Uruguaya" },
  { pt: "Venezuelana", en: "Venezuelan", es: "Venezolana" },
  { pt: "Vietnamita", en: "Vietnamese", es: "Vietnamita" },
];

export const HAIR = [
  { pt: "Castanha", en: "Brown-haired", es: "Castaña" },
  { pt: "Grisalha", en: "Grey-haired", es: "Canosa" },
  { pt: "Loira", en: "Blonde", es: "Rubia" },
  { pt: "Morena", en: "Brunette", es: "Morena" },
  { pt: "Preta", en: "Black-haired", es: "De pelo negro" },
  { pt: "Ruiva", en: "Redhead", es: "Pelirroja" },
];

export const EYES = [
  { pt: "azuis", en: "blue", es: "azules" },
  { pt: "castanhos", en: "brown", es: "castaños" },
  { pt: "castanhos claros", en: "light brown", es: "castaños claros" },
  { pt: "cinzentos", en: "grey", es: "grises" },
  { pt: "mel", en: "hazel", es: "miel" },
  { pt: "pretos", en: "black", es: "negros" },
  { pt: "verdes", en: "green", es: "verdes" },
];

const norm = (s) => (s || "").trim().toLowerCase();

/**
 * Given a catalog and a raw pt value (or full localised object),
 * return the full {pt, en, es} triplet. Falls back to the raw pt for all
 * three languages when nothing matches — never loses data.
 */
export const expandFromCatalog = (catalog, current) => {
  const ptValue = typeof current === "string" ? current : current?.pt || "";
  if (!ptValue.trim()) return { pt: "", en: "", es: "" };
  const hit = catalog.find((entry) => norm(entry.pt) === norm(ptValue));
  if (hit) return { pt: hit.pt, en: hit.en, es: hit.es };
  // Fallback: preserve manual value across all langs (or existing en/es if present)
  if (typeof current === "object" && current) {
    return {
      pt: ptValue,
      en: current.en?.trim() ? current.en : ptValue,
      es: current.es?.trim() ? current.es : ptValue,
    };
  }
  return { pt: ptValue, en: ptValue, es: ptValue };
};

/** True when the pt value matches a catalog entry exactly (case-insensitive). */
export const isInCatalog = (catalog, ptValue) =>
  !!catalog.find((entry) => norm(entry.pt) === norm(ptValue || ""));
